import { render, staticRenderFns } from "./CouponBirthPopup.vue?vue&type=template&id=5c93d7a0&scoped=true&"
import script from "./CouponBirthPopup.vue?vue&type=script&lang=js&"
export * from "./CouponBirthPopup.vue?vue&type=script&lang=js&"
import style0 from "./CouponBirthPopup.vue?vue&type=style&index=0&id=5c93d7a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c93d7a0",
  null
  
)

export default component.exports